import { observer } from 'mobx-react-lite';
import PubSub from 'pubsub-js';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useConfig } from '../../hooks';
import { useStores } from '../../stores';
import { PUBSUB_SURVEY } from '../../utilities';
import IconButton from '../IconButton';
import CloseIcon from '../Icons/Close';
import { ControlsItem } from './Controls';

const SurveyButton = (props, ref) => {
  const { chat } = useStores();
  const {
    header: {
      title: { color, iconColor }
    },
    window: { variant }
  } = useConfig();
  const { i18n, t } = useTranslation();

  if (!chat.isUserMessage) {
    return null;
  }

  if (variant !== 'fullscreen') {
    return null;
  }

  return (
    <ControlsItem ref={ref} {...props} className="react-rnd-draggable-cancel">
      <IconButton
        onClick={() => {
          PubSub.publish(PUBSUB_SURVEY);
        }}
        title={i18n.exists('altText.survey') ? t('altText.survey') : ''}
      >
        <CloseIcon fill={iconColor || color} />
      </IconButton>
    </ControlsItem>
  );
};

export default observer(SurveyButton, { forwardRef: true });
